exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adjudicationSchedule .day[data-v-3db9908a]{text-align:center;color:#000000}.adjudicationSchedule .day .day-text[data-v-3db9908a]{text-align:center;margin-top:20px;color:#4A89DC}.is-selected[data-v-3db9908a]{color:#1989FA}\n", ""]);

// exports
